import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AsyncNotNullPipe } from '@new/common/pipes/async-not-null.pipe';
import { requestStateSuccess } from '@new/common/utils/remote-data-utils';
import { isDefined } from '@new/common/utils/type-guards/is-defined';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UserFormState } from '../../state/user-form.state';

@Component({
  templateUrl: './user-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'container content' },
  standalone: true,
  imports: [TranslateModule, CommonModule, AsyncNotNullPipe, RouterModule]
})
export class UserEditComponent {
  public userFullName$: Observable<string>;
  public failure$: Observable<boolean>;

  constructor(private store: Store) {
    this.failure$ = this.store.select(UserFormState.userFailure);
    this.userFullName$ = this.store.select(UserFormState.user).pipe(
      filter(requestStateSuccess),
      map(({ data }) => data),
      filter(isDefined),
      map(user => `${user.lastName} ${user.firstName}`)
    );
  }
}
